import { COLOURS } from './colours';
import Icon from './shared/Icon/Icon';
import { Flex } from 'antd';

export const ICONS = { 
  BARS : 'BARS',
  PLUS : 'PLUS',
  HOUSE : 'HOUSE',
  CLUB: 'CLUB',
  USER_PLUS : 'USER_PLUS',
  BADGE_CHECK : 'BADGE_CHECK',
  BADMINTON : 'BADMINTON',
  SHUTTLECOCK : 'SHUTTLECOCK',
  USER_GROUP : 'USER_GROUP',
  CALENDAR_DAYS : 'CALENDAR_DAYS',
  CALENDAR_CHECK : 'CALENDAR_CHECK',
  CALENDAR_PLUS: 'CALENDAR_PLUS',
  CALENDAR_EDIT: 'CALENDAR_EDIT',
  CHART_LINE : 'CHART_LINE',
  COG : 'COG',
  PEOPLE_ARROWS : 'PEOPLE_ARROWS',
  PLAY : 'PLAY',
  CHECK : 'CHECK',
  WARNING: 'WARNING',
  PENDING: 'PENDING',
  CALENDAR : 'CALENDAR',
  PEOPLE : 'PEOPLE',
  PERSON : 'PERSON',
  USER_GEAR : 'USER_GEAR',
  USER_XMARK : 'USER_XMARK',
  USER_CHECK : 'USER_CHECK',
  TRASH : 'TRASH',
  TABLE : 'TABLE',
  FREE: 'FREE',
  BAN: 'BAN',
  MAP_LOCATION: 'MAP_LOCATION',
  GLOBE_POINTER: 'GLOBE_POINTER',
  COURT_SPORT: 'COURT_SPORT',
  PERSON_SIMPLE: 'PERSON_SIMPLE',
  PERSON_CIRCLE_CHECK: 'PERSON_CIRCLE_CHECK',
  PERSON_CIRCLE_PLUS: 'PERSON_CIRCLE_PLUS',
  CREDIT_CARD: 'CREDIT_CARD',
  XMARK: 'XMARK',
  CIRCLE : 'CIRCLE',
  CIRCLE_HALF_LEFT: 'CIRCLE_HALF_LEFT',
  CIRCLE_HALF_RIGHT: 'CIRCLE_HALF_RIGHT',
  CIRCLE_SMALL : 'CIRCLE_SMALL',
  CIRCLE_DOT: 'CIRCLE_DOT',
  CIRCLE_EXCLAMATION : 'CIRCLE_EXCLAMATION',
  CIRCLE_XMARK : 'CIRCLE_XMARK',
  CIRCLE_CHECK: 'CIRCLE_CHECK',
  CIRCLE_QUESTION: 'CIRCLE_QUESTION',
  QUESTION: 'QUESTION',
  BANK : 'BANK',
  INFO: 'INFO',
  INFO_CIRCLE: 'INFO_CIRCLE',
  SUBSCRIPTION: 'SUBSCRIPTION',
  TASK: 'TASK',
  FINISHED: 'FINISHED', 
  TROPHY: 'TROPHY', 

  CLOSE_FILTER: 'CLOSE_FILTER',
  FILTER: 'FILTER',
  CLEAR_FILTER: 'CLEAR_FILTER',
  MERGE: 'MERGE',
  MESSAGES: 'MESSAGES',
  SEND: 'SEND',
  DELIVERED: 'DELIVERED', 
  READ: 'READ',

  REFRESH: 'REFRESH', 
  RESET: 'RESET', 
  EXPAND: 'EXPAND', 
  CONTRACT: 'CONTRACT',

  // keys
  SQUARE: 'SQUARE',
  SHIFT: 'SHIFT',
  ENTER: 'ENTER',
  META: 'META',

  ARROW_DOWN_RIGHT: 'ARROW_DOWN_RIGHT',
  ARROW_UP_RIGHT: 'ARROW_UP_RIGHT',
  ARROW_LEFT: 'ARROW_LEFT',

  CARET_DOWN: 'CARET_DOWN',
  CARET_UP: 'CARET_UP',
  CHEVRON_DOWN: 'CHEVRON_DOWN',
  CHEVRON_UP: 'CHEVRON_UP',

  REMOVE_PLAYER: 'REMOVE_PLAYER',
  ADD_PLAYER: 'ADD_PLAYER',

  GBP: 'GBP',

  EMAIL: 'EMAIL',
  MOBILE: 'MOBILE',

  CHEVRONS_RIGHT: 'CHEVRONS_RIGHT', 
  CHEVRONS_LEFT: 'CHEVRONS_LEFT',

  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  ELIPSIS: 'ELIPSIS',

  NO_ICON : 'NO_ICON',

  STAR: 'STAR',

  STRIPE: 'STRIPE', 

  SHUTTLEOPS_SHUTTLE : 'SHUTTLEOPS_SHUTTLE',
  SHUTTLEOPS_SO: 'SHUTTLEOPS_SO'
}

const iconProperties = {
  [ICONS.BARS]: { name: 'bars' },
  [ICONS.PLUS]: { name: 'plus' },
  [ICONS.USER_PLUS]: { name: 'user-plus' },
  [ICONS.HOUSE]: { name: 'house' },
  [ICONS.CLUB]: { name: 'people-group'},
  [ICONS.BADGE_CHECK]: { name: 'badge-check' },
  [ICONS.BADMINTON] : { name: 'badminton' },
  [ICONS.SHUTTLECOCK] : { name: 'shuttlecock' },
  [ICONS.USER_GROUP] : { name: 'user-group' },
  [ICONS.CALENDAR_DAYS] : { name: 'calendar-days' },
  [ICONS.CALENDAR_CHECK] : { name : 'calendar-check' },
  [ICONS.CALENDAR_PLUS] : { name : 'calendar-plus' },
  [ICONS.CALENDAR_EDIT] : { name : 'calendar-pen' },
  [ICONS.CHART_LINE] : { name: 'chart-line' },
  [ICONS.COG] : { name: 'cog' },
  [ICONS.PEOPLE_ARROWS] : { name: 'people-arrows' },
  [ICONS.PLAY] : { name: 'play' },
  [ICONS.CHECK] : { name: 'check' },
  [ICONS.WARNING] : { name : 'diamond-exclamation' },
  [ICONS.PENDING] : { name : 'loader' },
  [ICONS.CALENDAR] : { name: 'calendar' },
  [ICONS.PEOPLE] : { name: 'people' },
  [ICONS.PERSON] : { name: 'person' },
  [ICONS.USER_GEAR] : { name: 'user-gear' },
  [ICONS.USER_XMARK] : { name: 'user-xmark' },
  [ICONS.USER_CHECK] : { name: 'user-check' },
  [ICONS.TRASH] : { name: 'trash' },
  [ICONS.TABLE] : { name: 'table' },
  [ICONS.FREE] : { name: 'square-0' },
  [ICONS.BAN] : { name: 'ban' },
  [ICONS.MAP_LOCATION] : { name: 'map-location' },
  [ICONS.GLOBE_POINTER] : { name: 'globe-pointer' },
  [ICONS.COURT_SPORT] : { name: 'court-sport' },
  [ICONS.PERSON_SIMPLE]: { name: 'person-simple' },
  [ICONS.PERSON_CIRCLE_CHECK]: { name: 'person-circle-check' },
  [ICONS.PERSON_CIRCLE_PLUS]: { name: 'person-circle-plus' },
  [ICONS.CREDIT_CARD]: { name: 'credit-card' },
  [ICONS.XMARK]: { name: 'xmark' },
  [ICONS.CIRCLE] : { name : 'circle' },
  [ICONS.CIRCLE_HALF_LEFT] : { name : 'circle-half' },
  [ICONS.CIRCLE_HALF_RIGHT] : { name : 'circle-half', flip: 'horrizontal'},
  [ICONS.CIRCLE_SMALL] : { name : 'circle-small' },
  [ICONS.CIRCLE_DOT] : { name : 'circle-dot' },
  [ICONS.CIRCLE_QUESTION]: { name : 'circle-question', secondary : COLOURS.PRIMARY, primary: 'white', secondaryOpacity: 1 },
  [ICONS.QUESTION]: { name : 'question', secondary : COLOURS.PRIMARY, primary: 'white', secondaryOpacity: 1 },
  [ICONS.CIRCLE_EXCLAMATION] : { name: 'circle-exclamation' },
  [ICONS.CIRCLE_XMARK]: { name : 'circle-xmark' },
  [ICONS.CIRCLE_CHECK]: { name: 'circle-check' },
  [ICONS.BANK] : { name: 'wallet' },
  [ICONS.SUBSCRIPTION] : { name: 'money-bill-transfer' },
  [ICONS.GBP] : { name: 'sterling-sign' },
  [ICONS.INFO] : { name: 'info' },
  [ICONS.INFO_CIRCLE] : { name: 'info-circle', secondary : COLOURS.PRIMARY, primary: 'white', secondaryOpacity: 1 },
  [ICONS.TASK] : { name : 'clipboard-list' },
  [ICONS.FINISHED] : { name : 'flag-checkered' },
  [ICONS.TROPHY] : { name : 'trophy' },
  [ICONS.FILTER] : { name : 'filter-list'},
  [ICONS.CLEAR_FILTER] : { name : 'filter-slash'},
  [ICONS.CLOSE_FILTER] : { name : 'filter-circle-xmark'},
  [ICONS.MERGE] : { name : 'merge'},
  [ICONS.MESSAGES] : { name : 'messages'},
  [ICONS.SEND] : { name : 'paper-plane' },
  [ICONS.DELIVERED] : { name : 'check' },
  [ICONS.READ] : { name : 'check-double' },
  
  [ICONS.REFRESH] : { name : 'arrows-rotate' },
  [ICONS.RESET] : { name : 'power-off' },
  [ICONS.EXPAND] : { name : 'expand' },
  [ICONS.CONTRACT] : { name : 'compress' },


  [ICONS.SQUARE] : { name : 'square' },
  [ICONS.SHIFT] : { name : 'up' },
  [ICONS.ENTER] : { name : 'turn-down-left' },
  [ICONS.META] : { name : 'command' },

  [ICONS.ARROW_DOWN_RIGHT]: { name : 'arrow-down-right' },
  [ICONS.ARROW_UP_RIGHT]: { name : 'arrow-up-right' },
  [ICONS.ARROW_LEFT]: { name : 'arrow-left' },
  [ICONS.CARET_DOWN]: { name : 'caret-down' },
  [ICONS.CARET_UP]: { name : 'caret-up' },
  [ICONS.CHEVRON_DOWN]: { name : 'chevron-down' },
  [ICONS.CHEVRON_UP]: { name : 'chevron-up' },

  [ICONS.REMOVE_PLAYER]: { name : 'person-circle-minus' },
  [ICONS.ADD_PLAYER]: { name : 'person-circle-plus' },
  
  [ICONS.LOGIN] : { name: 'arrow-right-to-bracket' },
  [ICONS.LOGOUT] : { name: 'arrow-left-to-bracket' },
  [ICONS.ELIPSIS] : { name: 'ellipsis-vertical' },

  [ICONS.EMAIL] : { name : 'at' },
  [ICONS.MOBILE] : { name : 'mobile' },

  [ICONS.CHEVRONS_RIGHT] : { name : 'chevrons-right' },
  [ICONS.CHEVRONS_LEFT] : { name : 'chevrons-left' },

  [ICONS.NO_ICON] : { name: 'light-emergency-on' },

  [ICONS.STRIPE] : { name: 'stripe-s' },

  [ICONS.STAR] : { name: 'star' },

  [ICONS.SHUTTLEOPS_SHUTTLE] : { name: 'shuttleops-shuttle' },
  [ICONS.SHUTTLEOPS_SO] : { name: 'shuttlops-so' }

}

const whiteModifier = { 
  primary: 'white', 
  secondary: 'white'
}

const warningModifier = { 
  primary: 'red', 
  secondary: 'red'
}

export const getIcon = ( name, isWhite = false, props = {} ) => { 
  if ( props.disabled ) { 
    props.primaryOpacity = 0.2;
    props.secondaryOpacity = 0.2;
  }
  if ( iconProperties[name] ) { 
    return <Icon {...iconProperties[name]} { ...(isWhite ? whiteModifier : {}) } {...props}/> 
  } else if ( typeof name === "object" ) { 
    return <Icon {...name} { ...warningModifier } {...props}/> 
  } else { 
    return <Icon {...iconProperties[ICONS.NO_ICON]} { ...warningModifier } {...props}/> 
  }
}

export const getStackedIcon = ( icon1, isWhite1, icon2, isWhite2, props = {}, props2 = {} ) => { 
  // the bigger one is first..
  let icon1Props = { 
    ...props,
    className: 'fa-stack-2x' 
  }

  let icon2Props = { 
    ...props,
    ...props2,
    className: 'fa-stack-1x' 
  }

  return <Flex className="fa-layers fa-fw fa-stack">
    { getIcon ( icon1, isWhite1, icon1Props ) }
    { getIcon ( icon2, isWhite2, icon2Props ) }
  </Flex>
}


